import { useState } from "react";

/** The image URL to render: the placeholder when the URL is blank or failed to load. A new URL is tried again. */
export const useImageFallback = (imageUrl: string | undefined, placeholder: string) => {
  const [failedUrl, setFailedUrl] = useState<string>();
  const trimmedUrl = imageUrl?.trim();
  const isUsable = Boolean(trimmedUrl) && failedUrl !== imageUrl;

  return {
    src: isUsable ? (imageUrl as string) : placeholder,
    onError: () => setFailedUrl(imageUrl),
  };
};
